import React, { Component } from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import Header from '../../Components/Header';
import EpaySuccessImg from '../../img/epaysuccess.svg';
import { setWaitCampaign } from '../../_redux/actions/campaign';
import BoxSize from '../../style/styledComponents/BoxSize';
class EpaySuccess extends Component {
	constructor() {
		super();

		this.state = {
			loja: null
		};
	}

	componentDidMount() {
		if (window.jQuery) {
			let $ = window.jQuery;
		}
	}

	/*sendCode() {
		//
		let loja = 'yalo';
		this.props.history.push(process.env.PUBLIC_URL + `/${loja}/beneficiario`);
	}*/

	render() {
		const { loja } = this.props.match.params;
		let signatureType;

		const { GiftCode } = this.props;
		signatureType = GiftCode.data.plan.signatureType;

		let epay = '';
		if (loja === 'epay') {
			epay = (
				<div className=' footer-adjustment'>
					<Header {...this.props} />

					<BoxSize className='box-content-success'>
						<img src={EpaySuccessImg} />
						<div className='content-align'>
							<h3>
								Está tudo certo com seu cupom! Agora vamos para o cadastro!
							</h3>
						</div>

						{/* <Link to={`/epay/beneficiario?assinatura=${signatureType}`}> */}
						<Link to={`/loja/epay/beneficiario?assinatura=${signatureType}`}>
							<button className='btn-forward'>PRÓXIMO PASSO</button>
						</Link>
					</BoxSize>
				</div>
			);
		}
		return <div className='page-wrapper'>{epay}</div>;
	}
}

const mapStateToProps = actionObject => {
	return actionObject;
};

const mapDispatchToProps = dispatch =>
	bindActionCreators({ setWaitCampaign }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(EpaySuccess);
